import { fromJS } from 'immutable';

export default function funnel(referrer) {
  const initialState = fromJS({
    referrer: referrer || null,
  });

  return function(state = initialState, action = {}) {
    switch (action.type) {
      default:
        return state;
    }
  };
}
